import * as moment from 'moment';

export class DateUtils {
    private static inMillis(unit): number {
        let toMillis = 1;
        switch (unit) {
            case 'days':
                toMillis *= 24;
            case 'hours':
                toMillis *= 60;
            case 'minutes':
                toMillis *= 60;
            case 'seconds':
                toMillis *= 1000;
        }
        return toMillis;
    }

    static diff(start: Date, end: Date, unit: 'millis' | 'seconds' | 'minutes' | 'hours' | 'days' = 'millis'): number {
        const millis = this.inMillis(unit);
        const diffTime = end.getTime() - start.getTime();
        return Math.ceil(diffTime / millis);
    }

    static add(date: Date, value: number, unit: 'millis' | 'seconds' | 'minutes' | 'hours' | 'days' = 'millis'): Date {
        const millis = this.inMillis(unit) * value;
        return new Date(date.getTime() + millis);
    }

    static getDatesArray(startDate: Date, endDate: Date, format: string = 'YYYY-MM-DD') {
        const dateArray = [];
        const stopDate = moment(endDate);
        let currentDate = moment(startDate);
        while (currentDate <= stopDate) {
            dateArray.push(moment(currentDate).format(format));
            currentDate = moment(currentDate).add(1, 'days');
        }
        return dateArray;
    }

    static computeSecondsMinutesHours(timeCount: number) {
        let seconds = Math.floor(timeCount);
        let minutes = Math.floor(seconds / 60);
        seconds = seconds - minutes * 60;
        const hours = Math.floor(minutes / 60);
        minutes = minutes - hours * 60;
        return {seconds, minutes, hours};
    }

    /***
     * Get last {{index}} months, considering currentMonth
     * @param index
     * @param currentMonth
     */
    static getLastMonths(index: number = 6, currentMonth?: number) {
        const months = [];
        if (!currentMonth) {
            currentMonth = (new Date()).getMonth() + 1;
        }
        if (currentMonth >= index) {
            for (let i = currentMonth; i > currentMonth - 6; i--) {
                months.push({label: DateUtils.getMonthByNumber(i), value: i});
            }
        } else {
            for (let i = currentMonth; i >= 1; i--) {
                months.push({label: DateUtils.getMonthByNumber(i), value: i});
            }
            const n = index - currentMonth;
            for (let i = 12; i > 12 - n; i--) {
                months.push({label: DateUtils.getMonthByNumber(i), value: i});
            }
        }
        return months;
    }

    static getMonthByNumber(i: number): string {
        const months = ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie',
            'Octombrie', 'Noiembrie', 'Decembrie'];
        return months[i - 1];
    }
}
